import { AbstractControl, ValidatorFn } from '@angular/forms';

export function notEmptyObject(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value && Object.keys(control.value).length === 0) {
      return { 'notEmptyObject': { value: control.value } };
    }
  };
}